;(function (angular) {
  'use strict'

  angular
    .module('kilo.common.directives')
    .directive('currencyFormatter', CurrencyFormatter)

  CurrencyFormatter.$inject = [ '$filter' ]

  function CurrencyFormatter ($filter) {
    return {
      restrict: 'A',
      require: 'ngModel',
      scope: {
        min: '=',
        max: '='
      },
      link: function (scope, elem, attrs, ngModel) {
        var numeral = $filter('numeral')
        function formatValue (v) {
          return numeral(v, '0,0[.]00 $')
        }

        ngModel.$formatters.push(formatValue)
        ngModel.$parsers.push(function (value) {
          value = value.replace(/\s/g, '')
          value = value.replace(',', '.')
          return Math.round((parseFloat(value) * 100))
        })

        elem.bind('blur', function () {
          let displayedValue = ''
          if (!ngModel.$valid) {
            displayedValue = formatValue(ngModel.$viewValue)
          } else {
            displayedValue = formatValue(ngModel.$modelValue)
          }
          ngModel.$viewValue = displayedValue
          ngModel.$render()
        })

        ngModel.$validators.min = (modelValue, viewValue) => {
          if (scope.min === undefined || scope.min === null) {
            return true
          }
          return modelValue >= scope.min
        }
        ngModel.$validators.max = (modelValue, viewValue) => {
          if (scope.max === undefined || scope.max === null) {
            return true
          }
          return modelValue <= scope.max
        }
      }
    }
  }
})(window.angular)
